export const operationMenuList = [
      {
            rowName: 'Orders',
            rowIcon: '../../../../assets/menu-icon/IconCart.svg',
            childMenuList: [
                  {
                        label: 'Purchase Order',
                        route: '/NewPurchaseOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PO_DETAILS'
                  },
                  {
                        label: 'Return Purchase Order',
                        route: '/po_returnPurchaseOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PRO_DETAILS'
                  },
                  {
                        label: 'Sales Order',
                        route: '/so_Orders',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_ORDERS'
                  },
                  {
                        label: 'Return Sales Order',
                        route: '/so_ReturnOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_RETURNORDER'
                  },
                  {
                        label: 'Stock Transfer',
                        route: '/so_StockTransfer',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_STOCKTRANSFER'
                  },
                  {
                        label: 'Air Shipments',
                        route: '/NewBookingList',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'AirShipment_DETAILS'
                  },
                  {
                        label: 'Allocation Rule',
                        route: '/order-allocation-rule',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'so_OrderAllocationRule'
                  }
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "PO_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PRO_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "SO_ORDERS" },
                  { "rightcode": "VIEW", "screencode": "SO_RETURNORDER" },
                  { "rightcode": "VIEW", "screencode": "SO_STOCKTRANSFER" },
                  { "rightcode": "VIEW", "screencode": "AirShipment_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "so_OrderAllocationRule" },
            ])
      },
      {
            rowName: 'Inventory',
            rowIcon: '../../../../assets/menu-icon/IconInventory.svg',
            childMenuList: [
                  {
                        label: 'Goods Inward',
                        route: '/GoodsInward',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GI_DETAILS'
                  },
                  // {
                  //       label: 'Put Away',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  {
                        label: 'Goods Outward',
                        route: '/so_GoodsOutward',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GO_DETAILS'
                  },
                  // {
                  //       label: 'Picking',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Dispatch',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Kit Order',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Stock Transfer',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Stock Take',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "GI_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "GO_DETAILS" },
            ])
      },
      {
            rowName: 'Shipment Request',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  {
                        label: 'Full Truck Load',
                        route: '/FtlList',
                        isSubChild: false,
                        // subChildMenuList: [
                        //       {
                        //             label: 'Sub Menu',
                        //       },
                        //       {
                        //             label: 'Sub Menu2',
                        //       }
                        // ],
                        rightcode: 'VIEW',
                        screencode: 'FTL_DETAILS'
                  },
                  // {
                  //       label: 'Part Truck Load',
                  //       route: '',
                  //       isSubChild: true,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Container Movement',
                  //       route: '',
                  //       isSubChild: true,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Courier',
                  //       route: '/new-courier',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BY_COURIER'
                  // },
                  // {
                  //       label: 'Bidding',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "FTL_DETAILS" },
            ])
      },
      // {
      //       rowName: 'Planning',
      //       rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
      //       childMenuList: [
      //             {
      //                   label: 'View Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Trip Planning',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Route Optimization',
      //                   route: '/trip-planning-map',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: 'ROUTE_OPTIMIZATION'
      //             },

      //       ],
      //       rightsList: []
      // },
      // {
      //       rowName: 'Execution',
      //       rowIcon: '../../../../assets/menu-icon/Iconexecution.svg',
      //       childMenuList: [
      //             {
      //                   label: 'Assign Vehicle',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Pickup',
      //                   route: '',
      //                   isSubChild: true,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Active Trip',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Completed Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Cancelled Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },

      //       ],
      //       rightsList: []
      // },
      // {
      //       rowName: 'Visibility & Control',
      //       rowIcon: '../../../../assets/menu-icon/Iconvisibility.svg',
      //       childMenuList: [
      //             {
      //                   label: 'Analytics',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Live Tracking',
      //                   route: '/VehicleTracking',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Communication',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Alerts',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Calendar',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Rate Check',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Attachments',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //       ],
      //       rightsList: []
      // },
      {
            rowName: 'Fleet Management',
            rowIcon: '../../../../assets/menu-icon/Iconfeet-management.svg',
            childMenuList: [
                  {
                        label: 'Drivers',
                        route: '/NewDriver',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'DRIVERS_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Vehicles',
                        route: '/NewVehicleMaster',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'VEHICLES_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Tyres',
                        route: '',
                        isSubChild: true,
                        subChildMenuList: [
                              {
                                    label: 'Tyre List',
                                    route: '/NewTyreList',
                                    rightcode: 'VIEW',
                                    screencode: 'TYRELIST_DETAILS'
                              },
                              {
                                    label: 'Retreading',
                                    route: 'NewTyreRetreading',
                                    rightcode: 'VIEW',
                                    screencode: 'RETREADING_DETAILS'
                              },
                              {
                                    label: 'Repairs',
                                    route: 'NewTyreRepair',
                                    rightcode: 'VIEW',
                                    screencode: 'REPAIRS_DETAILS'
                              },
                              {
                                    label: 'Assign',
                                    route: 'NewTyreAssign',
                                    rightcode: 'VIEW',
                                    screencode: 'ASSIGN_DETAILS'
                              },
                              {
                                    label: 'Discard',
                                    route: 'NewTyreDiscard',
                                    rightcode: 'VIEW',
                                    screencode: 'DISCARD_DETAILS'
                              }
                        ],
                        rightcode: 'VIEW',
                        screencode: '',
                        rightsList: JSON.stringify([
                              { "rightcode": "VIEW", "screencode": "TYRELIST_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "RETREADING_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "REPAIRS_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "ASSIGN_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "DISCARD_DETAILS" }
                        ])
                  },
                  {
                        label: 'Repairs & Maintenance',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'REPAIRSMAINTENANCE_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Vehicle Inspection',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'VEHICLEINSPECTION_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Reminders',
                        route: '',
                        isSubChild: true,
                        subChildMenuList: [
                              {
                                    label: 'Service',
                                    route: '',
                                    rightcode: 'VIEW',
                                    screencode: 'SERVICE_DETAILS'
                              },
                              {
                                    label: 'Renewal',
                                    route: '',
                                    rightcode: 'VIEW',
                                    screencode: 'RENEWAL_DETAILS'
                              },
                              {
                                    label: 'Task Type',
                                    route: '',
                                    rightcode: 'VIEW',
                                    screencode: 'TASKTYPE_DETAILS'
                              }
                        ],
                        rightcode: 'VIEW',
                        screencode: 'REMINDERS_DETAILS',
                        rightsList: []
                  },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "DRIVERS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "VEHICLES_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "REPAIRSMAINTENANCE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "VEHICLEINSPECTION_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "REMINDERS_DETAILS" },
            ])
      },
      {
            rowName: 'Reports',
            rowIcon: '../../../../assets/menu-icon/IconReports.svg',
            childMenuList: [
                  {
                        label: 'Orders',
                        route: '/NewOperationalReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'OPERATIONSREPORTS_DETAILS'
                  },
                  {
                        label: 'Accounts',
                        route: '/AccountReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ACCOUNTREPORTS_DETAILS'
                  },
                  {
                        label: 'Finance',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FINANCEREPORT_DETAILS'
                  },
                  {
                        label: 'Inventory',
                        route: '/InventoryReport',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'INVENTORYREPORT_DETAILS'
                  },
                  {
                        label: 'Masters',
                        route: '/Masters',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'Masters_DETAILS'
                  },


            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "OPERATIONSREPORTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "ACCOUNTREPORTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FINANCEREPORT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "INVENTORYREPORT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "Masters_DETAILS" },
            ])
      }
]

export const BookOfAccountsMenuList = [
      {
            rowName: 'Accounting',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  {
                        label: 'Pending Trips for Invoice',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Sales Invoice',
                        route: 'sales-invoice-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SALESINVOICE_DETAILS'
                  },
                  {
                        label: 'Pending Trips for Billing',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Purchase Invoice',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Wallet',
                        route: '/Wallet',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'WALLET_DETAILS'
                  },
            ],
            rightsList: []
      },
      {
            rowName: 'Bank & Cash',
            rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
            childMenuList: [
                  {
                        label: 'Receipts',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Cash Receipts',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Advance Payments',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Payments',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Payment Request',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Payment Schedule',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Cash Expense',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
                  {
                        label: 'Bank Statement',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },

            ],
            rightsList: []
      },
]

export const SettingMenuList = [
      {
            rowName: 'Accounts',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  {
                        label: 'Chart of Accounts',
                        route: '/NewChartOfAccounts',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARTOFACCOUNT_DETAILS'
                  },
                  {
                        label: 'Opening Balance',
                        route: '/opening-balance-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'OPENINGBALANCE_DETAILS'
                  },
                  {
                        label: 'Accounting Period',
                        route: '/accounting-period-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ACCOUNTINGPERIOD_DETAILS'
                  },
                  {
                        label: 'Manage Taxes',
                        route: '/NewManageTaxes',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETAXES_DETAILS'
                  },
                  {
                        label: 'Manage Cess',
                        route: '/NewManageCess',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETAXES_DETAILS'
                  },
                  {
                        label: 'Manage Exemptions',
                        route: '/NewTaxExemptionsModule',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TAXEXEMPTIONS_DETAILS'
                  },
                  {
                        label: 'Manage TDS',
                        route: '/NewManageTds',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETDS_DETAILS'
                  },
                  {
                        label: 'Invoice Type',
                        route: '/new-invoice-type',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARGETYPE_DETAILS'
                  },
                  {
                        label: 'Charges',
                        route: '/charges-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARGE_DETAILS'
                  },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "CHARTOFACCOUNT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "OPENINGBALANCE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "ACCOUNTINGPERIOD_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "MANAGETAXES_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "TAXEXEMPTIONS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "MANAGETDS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "CHARGETYPE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "CHARGE_DETAILS" }
            ])
      },
      {
            rowName: 'Masters',
            rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
            childMenuList: [
                  {
                        label: 'Settings',
                        route: '/NewSettings',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SETTINGS_DETAILS'
                  },
                  {
                        label: 'Network',
                        route: '/NewNetwork',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'NETWORK_DETAILS'
                  },
                  {
                        label: 'Product Category',
                        route: '/business-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ProductCategory_DETAILS'
                  },
                  {
                        label: 'Products',
                        route: '/new-products',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PRODUCTS_DETAILS'
                  },
                  {
                        label: 'Fuel Price',
                        route: '/newfuel',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FUELPRICE_DETAILS'
                  },
                  {
                        label: 'Fuel Pump',
                        route: '/newfuelpricepumpwise',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FUELPUMP_DETAILS'
                  },
                  {
                        label: 'Target',
                        route: '/new-target',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TARGET_DETAILS'
                  },

            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "SETTINGS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "NETWORK_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "BYVEHICLE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PRODUCTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FUELPRICE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FUELPUMP_DETAILS" }
            ])
      },

]

export const NavMenus = [
      { header: 'Operations', list: operationMenuList },
      // { header: 'Books of Accounts', list: BookOfAccountsMenuList },
      { header: 'Settings', list: SettingMenuList }
]